import Tone from 'tone';

const createReverb = callback => new Tone.Convolver({
  url: './everything2.wav',
  wet: .4,
  onload: callback
});

const feedbackDelay = new Tone.FeedbackDelay({
  delayTime: "1m",
  feedback: 0.5,
  wet: .3
});

new Tone.LFO({
  frequency: '2m',
  min: 0,
  max: .4,
  phase: Math.random() * 360
}).connect(feedbackDelay.wet).start();
new Tone.LFO({
  frequency: '3m',
  min: 0,
  max: .7,
  phase: Math.random() * 360
}).connect(feedbackDelay.feedback).start();

const EQ = new Tone.EQ3(-1, 0, 0);

export default callback => [
  feedbackDelay,
  createReverb(callback),
  EQ,
];



// WEBPACK FOOTER //
// ./src/effects.js